import React, { useCallback } from 'react';
import { useSlotScreenGeneratorStore } from '@store/slotScreenGeneratorStore';
import { ComponentCard } from './ComponentCard';

export function ComponentListStrip() {
  const components = useSlotScreenGeneratorStore(s => s.screenComponents[s.activeScreenId] ?? []);
  const selectedId = useSlotScreenGeneratorStore(s => s.selectedComponentId);

  const sorted = [...components].sort((a, b) => a.zIndex - b.zIndex);

  const handleSelect = useCallback((id: string) => {
    useSlotScreenGeneratorStore.getState().selectComponent(id);
  }, []);

  const handleDoubleClick = useCallback((id: string) => {
    useSlotScreenGeneratorStore.getState().openGeneratorView(id);
  }, []);

  return (
    <div className="flex-shrink-0 border-t border-zinc-800 bg-zinc-900/50">
      <div className="flex items-center gap-1 px-3 py-1.5">
        <span className="text-[10px] text-zinc-500 uppercase tracking-wider mr-2">Components</span>
        <span className="text-[10px] text-zinc-600">{sorted.length}</span>
      </div>
      <div className="flex gap-2 px-3 pb-2 overflow-x-auto">
        {sorted.map(comp => (
          <ComponentCard
            key={comp.id}
            component={comp}
            isSelected={comp.id === selectedId}
            onSelect={handleSelect}
            onDoubleClick={handleDoubleClick}
          />
        ))}
      </div>
    </div>
  );
}
